module.exports = __webpack_public_path__ + "static/JetBrainsMono-Regular-3eacd63796de4b39bc102dae7b143ca5.woff2";